<swiper
  #scrollElement
  *ngIf="ads?.length"
  class="banner-slider"
  [class.with-pager]="ads?.length > 1"
  [dir]="sliderScrollingDirection"
  [config]="config"
>
  <ng-template swiperSlide *ngFor="let ad of ads">
    <div class="banner" tappable (click)="selectBanner.emit(ad)">
      <div [attr.data-src]="ad.imageUrl" class="lazy-loading-image not-loaded animated-image">
        <div class="lazy-loading-image-content" [style.backgroundImage]="ad.imageUrl ? 'url(' + ad.imageUrl + ')' : null"></div>
      </div>
    </div>
  </ng-template>
</swiper>
